import { Text } from '@change/ds-core-ui';
import { WarningIcon } from '@change/ds-icons';

import { Button } from '../Button';

import { useAmountInput } from './hooks/useAmountInput';
import type { AmountInputProps } from './index.types';

export const AmountInputCard: React.FC<AmountInputProps> = ({
	currencySymbol,
	currencySymbolPosition,
	label,
	showFractionNumber,
	decimalSeparator,
	'data-qa': dataQa,
	...hookProps
}) => {
	const {
		data: { showOther, inputWidthCh, applySelectedStyle, inputRef, valueInDecimal },
		actions: { handleActivate, handleChange, handleKeyDown, handleBlur },
	} = useAmountInput(hookProps);

	const { error } = hookProps;

	return (
		<>
			<Button
				className="relative"
				error={!!error}
				selected={!!applySelectedStyle}
				onClick={handleActivate}
				data-qa={dataQa}
			>
				<div className="flex w-full items-center">
					{showOther && (
						<Text variant="body" size="medium" fontWeight="bold">
							{label}
						</Text>
					)}
					{!showOther && (
						<div className="flex items-baseline">
							{currencySymbolPosition === 'before' && (
								<Text variant="body" size="medium" fontWeight="bold" className="pr-1">
									{currencySymbol}
								</Text>
							)}
							<input
								ref={inputRef}
								id="amount-input"
								inputMode="numeric"
								pattern="[0-9]*"
								value={valueInDecimal}
								onChange={handleChange}
								onKeyDown={handleKeyDown}
								onBlur={handleBlur}
								className="text-body-medium caret-typography-default min-w-0 bg-transparent text-right font-bold outline-none"
								style={{ width: `${inputWidthCh}ch` }}
							/>
							{showFractionNumber && (
								<Text variant="body" size="medium" fontWeight="bold">
									{decimalSeparator}00
								</Text>
							)}
							{currencySymbolPosition === 'after' && (
								<Text variant="body" size="medium" fontWeight="bold" className="pl-1">
									{currencySymbol}
								</Text>
							)}
						</div>
					)}
				</div>
			</Button>
			{error && (
				<div className="flex gap-1" data-qa="custom-amount-error-message">
					<WarningIcon size="small" className="text-icon-error" />
					<Text variant="body" size="small" className="text-typography-error">
						{error}
					</Text>
				</div>
			)}
		</>
	);
};
